import React from 'react';
import { css, cx } from '@linaria/core';

const loaderClassnames = {
  root: css`
    @keyframes bambuser-loader-notranslate-spin {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }
    
    width: 36px;
    height: 36px;
    border-radius: 28px;
    border-color: #000 #000 transparent;
    border-style: solid;
    border-width: 1px;
    animation: bambuser-loader-notranslate-spin 0.8s linear infinite;
  `,
  absolute: css`
    @keyframes bambuser-loader-spin {
      from {
        transform: translate(-50%, -50%) rotate(0deg);
      }

      to {
        transform: translate(-50%, -50%) rotate(360deg);
      }
    }
    
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
    animation: bambuser-loader-spin 0.8s linear infinite;
  `,
  relative: css`
    position: relative;
  `,
  white: css`
    border-color: #fff #fff transparent;
  `,
  small: css`
    width: 18px;
    height: 18px;
    border-radius: 14px;
  `,
};
const Loader = ({ type = 'normal', color = 'black', loading = true, style: overwriteStyles = {}, position = 'absolute' }) => {
  const className = cx(
    loaderClassnames.root,
    loaderClassnames[type],
    loaderClassnames[color],
    loaderClassnames[position],
  );

  if (!loading) return null;

  return <div className={className} style={overwriteStyles} role="progressbar" />;
};

export default Loader;
